import React, { useState } from 'react'
import toast from 'react-hot-toast'
import { AxiosError } from 'axios'
import { useMutation } from 'react-query'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core'
import { useQueryPaginator } from 'src/components/Table'

import { skuit } from 'src/services/skuit'
import { Audit, Place } from 'src/api/models'
import { PlaceListTable } from 'src/components/Table/list/Place'
import { Notification } from 'src/components/Notification'
import { queryClient } from 'src/App'

interface Props {
  audit?: Audit
  open: boolean
  handleClose: () => void
}

export const AuditResultPlaceAddDialog = (props: Props) => {
  const {audit, open, handleClose} = props
  const [selected, setSelected] = useState<Place[]>([])

  const placePaginator = useQueryPaginator('for-audit-places', skuit.sc.places.list, {
    params: { for_audit: audit?.guid },
  })

  const { mutate: addPlaces } = useMutation((places: string[]) => skuit.sc.audits.places.bulkAdd(audit?.guid as string, {places}), {
    onSuccess: () => {
      toast.success(() => <Notification message={`Successfully created Orders from csv`} />)
      placePaginator.refresh()
      queryClient.invalidateQueries('audit-places')
      handleClose()
    },
    onError: (error: AxiosError) => {
      toast.error(() => <Notification message={`Failed to process CSV: ${error}`} />)
    },
  })

  const onAdd = () => {
    const places = selected.map((place) => place.guid)
    addPlaces(places)
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>Add Places</DialogTitle>
      <DialogContent>
        <PlaceListTable
          title="Potential Places for Audit"
          paginator={placePaginator}
          fields={['path']}
          onSelectedItem={setSelected}
        />
      </DialogContent>
      <DialogActions>
        <Button color="primary" variant="contained" onClick={onAdd} disabled={!selected.length} >
          Add Places
        </Button>
      </DialogActions>
    </Dialog>
  )
}
